export default "__VITE_ASSET__42b8db89__"